import {
    LIST_FUNCTIONARIES,
    LIST_FUNCTIONARIES_SUCCESS,
    LIST_FUNCTIONARIES_ERROR,
    ADD_FUNCTIONARIES,
    SAVE_FUNCTIONARIES,
    SAVE_FUNCTIONARIES_SUCCESS,
    SAVE_FUNCTIONARIES_ERROR,
    DELETE_FUNCTIONARIES,
    DELETE_FUNCTIONARIES_SUCCESS,
    DELETE_FUNCTIONARIES_ERROR,
    EDIT_FUNCTIONARIES,
    ENABLE_FUNCTIONARIES,
    ENABLE_FUNCTIONARIES_SUCCESS,
    ENABLE_FUNCTIONARIES_ERROR,
    UPDATE_FUNCTIONARIES,
    UPDATE_FUNCTIONARIES_SUCCESS,
    UPDATE_FUNCTIONARIES_ERROR
} from '../types';

import clienteAxios                                                                 from '../config/axios';
import authToken                                                                    from '../config/token';
import Swal                                                                         from 'sweetalert2';

import { ErrorMessage, SuccessMessage, WaitingMessage }                             from '../components/extras/toastMessages';
import { MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS, MSG_CREATE_SUCCESS } from '../constants/messages';
import { METHOD_DISABLED }                                                          from '../constants/requestMethods';

import functionariesData                                                            from '../data/functionaries';

const controller = 'funcionario';



//LISTAR FUNCTIONARIES
export function listFunctionariesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listFunctionaries() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const functionaries = response.data;
            //const functionaries = functionariesData;
            //Llamo al dispatch
            dispatch( listFunctionariesSuccess(functionaries.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listFunctionariesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listFunctionaries = () => ({
    type: LIST_FUNCTIONARIES,
    payload: true
});

const listFunctionariesSuccess = functionaries => ({
    type: LIST_FUNCTIONARIES_SUCCESS,
    payload: functionaries
});

const listFunctionariesError = error => ({
    type: LIST_FUNCTIONARIES_ERROR,
    payload: error
});



//ADD AUDIENCE CATEGORY
export function addFunctionariesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addFunctionaries(false) );
        //Abro el formulario
        showForm();
    }
}

const addFunctionaries = isEdit => ({
    type: ADD_FUNCTIONARIES,
    payload: isEdit
});



//SAVE AUDIENCE CATEGORY
export function saveFunctionariesAction(functionary, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveFunctionaries() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, functionary);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveFunctionariesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveFunctionariesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveFunctionaries = () => ({
    type: SAVE_FUNCTIONARIES,
    payload: true
});

const saveFunctionariesSuccess = functionary => ({
    type: SAVE_FUNCTIONARIES_SUCCESS,
    payload: functionary
});

const saveFunctionariesError = error => ({
    type: SAVE_FUNCTIONARIES_ERROR,
    payload: error
});



//EDIT AUDIENCE CATEGORY
export function editFunctionariesAction(functionary, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editFunctionaries(functionary) );
        //Abro el formulario
        showForm();
    }
}

const editFunctionaries = functionary => ({
    type: EDIT_FUNCTIONARIES,
    payload: functionary
});



//ENABLE FUNCTIONARIES
export function enableFunctionariesAction(functionary) {
    return async (dispatch) => {
        dispatch( enableFunctionaries() );
        try {            
            const response = await clienteAxios.put(`/${controller}/${functionary.id}/activar`);
            dispatch( enableFunctionariesSuccess(response.data) );
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response)
            {   data = response.data;
            }
            dispatch( enableFunctionariesError(data) );
            ErrorMessage(data.message);
        }
    }
}

const enableFunctionaries = () => ({
    type: ENABLE_FUNCTIONARIES,
    payload: true
});

const enableFunctionariesSuccess = functionary => ({
    type: ENABLE_FUNCTIONARIES_SUCCESS,
    payload: functionary
});

const enableFunctionariesError = error => ({
    type: ENABLE_FUNCTIONARIES_ERROR,
    payload: error
});



//UPDATE AUDIENCE CATEGORY
export function updateFunctionariesAction(functionary, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateFunctionaries() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${functionary.id}`, functionary);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateFunctionariesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateFunctionariesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateFunctionaries = () => ({
    type: UPDATE_FUNCTIONARIES,
    payload: true
});

const updateFunctionariesSuccess = functionary => ({
    type: UPDATE_FUNCTIONARIES_SUCCESS,
    payload: functionary
});

const updateFunctionariesError = error => ({
    type: UPDATE_FUNCTIONARIES_ERROR,
    payload: error
});



//DELETE AUDIENCE CATEGORY
export function deleteFunctionariesAction(functionary) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteFunctionaries() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${functionary.id}`);
            const response = await clienteAxios.put(`/${controller}/${functionary.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteFunctionariesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteFunctionariesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteFunctionaries = () => ({
    type: DELETE_FUNCTIONARIES,
    payload: true
});

const deleteFunctionariesSuccess = functionary => ({
    type: DELETE_FUNCTIONARIES_SUCCESS,
    payload: functionary
});

const deleteFunctionariesError = error => ({
    type: DELETE_FUNCTIONARIES_ERROR,
    payload: error
});